import { serviceHelper } from '../utils/serviceHelper'

export const getNotificationByProfessionalId = async ({ id, skip = 0, limit = 5 }) => {
  const partnerApi = getAxiosCreate()
  const { data } = await partnerApi.get(`/notification/professional/?skip=${skip}&limit=${limit}`, { headers: { 'x-professional-user-id': id } })
  return data
}

export const getNotificationById = async (notificationId) => {
  const partnerApi = getAxiosCreate()
  const { data } = await partnerApi.get(`/notification/${notificationId}`)
  return data
}

export const updateNotificationToRead = async ({ partnerId, notificationId, professionalId }) => {
  const partnerApi = getAxiosCreate()
  const { data } = await partnerApi.post(`/notification/read/${partnerId}/${notificationId}`, { headers: { 'x-professional-user-id': professionalId } })
  return data
}

export const updateNotificationToAccepted = async ({ partnerId, notificationId, professionalId }) => {
  const partnerApi = getAxiosCreate()
  const { data } = await partnerApi.post(`/notification/accepted/${partnerId}/${notificationId}`, { headers: { 'x-professional-user-id': professionalId } })
  return data
}

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_PARTNER_URL}`)
}
